import { useLocation, useNavigate } from "react-router";
import Container from "../components/common/Container";
import PlusIcon from "../components/common/Icons/PlusIcon";
import PageHeader from "../components/common/PageHeader";
import ApplicantTable from "../components/Applicants/ApplicantsTable";

const Applicants = () => {
  const navigate = useNavigate();
  const location = useLocation();
  return (
    <Container>
      <PageHeader
        pageTitle="Başvuru Listesi"
        isButtoned
        buttonIcon={<PlusIcon />}
        buttonText="Yeni Başvuru"
        buttonOnClick={() => {
          navigate(`${location.pathname}/new`);
        }}
      />
      <ApplicantTable />
    </Container>
  );
};

export default Applicants;
